export enum DocumentUploadModalMode {
  ADD = "ADD",
  EDIT = "EDIT",
  ADD_LOMN = "ADD_LOMN",
  ADD_LAB_RESULTS = "ADD_LAB_RESULTS",
}

export enum DocumentUploadModalNavigationDirection {
  BACK = "BACK",
  CLOSE = "CLOSE",
}
